module.exports = __webpack_public_path__ + "static/media/Landing Page Banner_Mobile 1x.9d126cd7.png";